interface StoryBeat {
    id: string;
    eyebrow: string;
    headline: string;
    body: string;
    align: 'left' | 'right';
}

/**
 * Narrative beats that play out as the user scrolls.
 * The camera moves through these sections via CameraRig; the text fades in
 * using CSS intersection-observer (added per-beat via IntersectionObserver).
 *
 * The last two beats are in dark-mode territory (scroll > 0.55).
 */
const BEATS: StoryBeat[] = [
    {
        id: 'craft',
        eyebrow: 'Handwerk',
        headline: 'Jeder Ring ein Unikat',
        body: 'Gefertigt in unserer Schmuckmanufaktur in Radolfzell – von Hand, nach Maß, auf Wunsch.',
        align: 'left',
    },
    {
        id: 'profile',
        eyebrow: 'Das Profil',
        headline: 'Form folgt Gefühl',
        body: 'Klassisch gerundet oder schmal – das Profil entscheidet über den täglichen Tragekomfort.',
        align: 'right',
    },
    {
        id: 'material',
        eyebrow: 'Das Material',
        headline: 'Gold. Platin. Palladium.',
        body: 'Wir verarbeiten ausschließlich Metalle in Premiumqualität. Die Legierung bestimmt Farbe und Charakter.',
        align: 'left',
    },
    {
        id: 'dark',
        eyebrow: 'Licht & Dunkel',
        headline: 'Die Nachtseite des Schmucks',
        body: 'Unter UV-Licht erwacht das Besondere. Fluoreszierende Einlagen unter den Steinen und in den Ringen – für ein einzigartiges Erlebnis.',
        align: 'right',
    },
];

export default function StorySections() {
    return (
        <>
            {BEATS.map((beat) => (
                <StoryBeat key={beat.id} beat={beat} />
            ))}
        </>
    );
}

function StoryBeat({ beat }: { beat: StoryBeat }) {
    const isRight = beat.align === 'right';

    return (
        <section
            className="flex h-screen items-center px-8 md:px-20"
            data-story-beat={beat.id}
            aria-label={beat.headline}
        >
            <div
                className={[
                    'max-w-md',
                    isRight ? 'ml-auto text-right' : 'mr-auto text-left',
                    'story-beat-text opacity-0 translate-y-6 transition-all duration-700',
                ].join(' ')}
            >
                <p className="mb-2 text-xs tracking-[0.25em] uppercase text-[var(--fg-muted)]">
                    {beat.eyebrow}
                </p>
                <h2 className="font-serif text-4xl leading-tight text-[var(--fg)] md:text-5xl">
                    {beat.headline}
                </h2>
                <p className="mt-5 text-base leading-relaxed text-[var(--fg-muted)]">
                    {beat.body}
                </p>
            </div>
        </section>
    );
}
